export const COLOR_OPTIONS = {
  GREY: 'grey',
  WHITE: 'white',
  DARK: 'dark',
  NEUTRAL: 'neutral',
  LIGHTPURPLE: 'lightpurple',
  PURPLEGRADIENT: 'purplegradient',
} as const;

export interface IVariant {
  DARK: {
    backgroundColor: string;
    headlineColor: string;
    bodyColor: string;
  };
  WHITE: {
    backgroundColor: string;
    headlineColor: string;
    bodyColor: string;
  };
  GREY: {
    backgroundColor: string;
    headlineColor: string;
    bodyColor: string;
  };
  NEUTRAL: {
    backgroundColor: string;
    headlineColor: string;
    bodyColor: string;
  };
  LIGHTPURPLE: {
    backgroundColor: string;
    headlineColor: string;
    bodyColor: string;
  };
  PURPLEGRADIENT: {
    backgroundImage: string;
    headlineColor: string;
    bodyColor: string;
  };
}
